import { useState } from 'react'
import CustomTable from '@/components/CustomTable'
import CustomView from '@/components/CustomView'
import PageTitle from '@/components/PageTitle'
import DeleteChecklistModal from './components/DeleteChecklistModal'

interface IChecklistData {
  code: number
  name: string
  categoryGroup: string
  evaluationType: string
  assetManage: string
  assetType: string
  situation: string
  lastChange: string
  user: string
  id: string
}

const availableActions = ['Editar', 'Clonar', 'Inativar', 'Excluir']

const columnsArr = [
  'Código',
  'Nome',
  'Grupo de categoria',
  'Diretoria de ativos',
  'Tipo do ativo',
  'Situação',
  'Data da últ. atualização',
  'Usuário últ. atualização'
]

const dataMock: IChecklistData[] = [
  {
    code: 323546,
    name: 'Checklist de Vistoria Veicular',
    categoryGroup: 'Automóvel',
    evaluationType: 'Mobilização',
    assetManage: 'Administrativa',
    assetType: 'Leve',
    situation: 'Ativo',
    lastChange: '',
    user: 'Usuário A',
    id: '1'
  },
  {
    code: 323547,
    name: 'Checklist Desmobilização',
    categoryGroup: 'Caminhão',
    evaluationType: 'Desmobilização',
    assetManage: 'Siderurgia',
    assetType: 'Pesado',
    situation: 'Ativo',
    lastChange: '',
    user: 'Usuário B',
    id: '2'
  }
]

function Checklist() {
  const [data, setData] = useState<IChecklistData[]>(dataMock)
  const [count, setCount] = useState(0)
  const [modalDelete, setModalDelete] = useState({
    isOpen: false,
    data: null
  })

  const formFilter = () => {
    return <form onSubmit={() => {}}></form>
  }

  const handleAction = (action: string, row: any) => {
    if (action === 'Excluir') {
      setModalDelete({
        isOpen: true,
        data: row
      })
    }
  }

  const handleExport = async () => {}

  return (
    <CustomView>
      <PageTitle>Checklist</PageTitle>
      <CustomTable
        dataset={data}
        actions={availableActions}
        columns={columnsArr}
        newDataComponent="checklist"
        formFilter={formFilter()}
        handleExport={handleExport}
        totalCount={count}
        handleAction={handleAction}
        overrideAction={true}
        allowEditInactive
      />
      <DeleteChecklistModal
        open={modalDelete.isOpen}
        onConfirm={() => {}}
        onClose={() => setModalDelete({ isOpen: false, data: null })}
        data={modalDelete.data}
      />
    </CustomView>
  )
}

export default Checklist
